import script from "./TressCheckboxListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressCheckboxListItem.vue?vue&type=script&lang=ts&setup=true"

import "./TressCheckboxListItem.vue?vue&type=style&index=0&id=1a3e2890&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a3e2890"]])

export default __exports__